import React, { useRef } from 'react';
import { ThreeDots } from '@shared/icons/icons';
import { ContextMenu } from '@shared/contextmenu';
import { WidgetMenuContainer, WidgetMenuTrigger } from '@styled/Widget';
function WidgetMenu(_a) {
    var wrapperRef = _a.wrapperRef, menuItems = _a.menuItems, _b = _a.visible, visible = _b === void 0 ? true : _b;
    var menuBtnRef = useRef(null);
    return (React.createElement(WidgetMenuContainer, null,
        React.createElement(WidgetMenuTrigger, { ref: menuBtnRef },
            React.createElement(ThreeDots, null)),
        React.createElement(ContextMenu, { items: menuItems, triggerRefs: wrapperRef
                ? [{ ref: menuBtnRef, trigger: 'click' }, { ref: wrapperRef }]
                : [{ ref: menuBtnRef, trigger: 'click' }], visible: visible })));
}
export default WidgetMenu;
